module.exports = __webpack_public_path__ + "img/ic_active_user.e3891b25.png";